module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_M.088ed1ac.jpg";